

























import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";

import { NavigationService } from "../NavigationServices/navigation";
import {
	ContentStreamDTO,
	ListItemDTO,
	StreamStatsDTO
} from "../Generated/ParticaAPI";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCardMax from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ContentStreamStats from "@/Ui-Components/ContentStream/ContentStreamStats.vue";
import { ContentStreamService, IContentStreamService } from "../BusinessServices/contentstream";
import { ParticaListContent, ParticaListLineContent } from "../Models/ParticaListModel";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
import { ButtonConfig, ButtonStatus, ButtonType } from "../Models/Buttons";
import ParticaAccountBase from "./Base/ParticaAccountBase.vue";

@Component({
	components: {
		ParticaList2Line,
		ParticaRowContainer,
		ParticaCardMax,
		ParticaView,
		ContentStreamStats
	}
})
export default class ContentStreams extends ParticaAccountBase {
	@Prop() private id: number;
	private svc: IContentStreamService;
	private streams: StreamStatsDTO[] = []; // always init if not prop

	private streambuttons: ButtonConfig[] = [
		{
			label: "View",
			action: eParticaAction.CONTENT_STREAM_SELECT_STREAM,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	// handle event from the actionlist
	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_SELECT_STREAM: {
					this.$router.push({
						name: "contentstreamhome",
						params: { id: event.item.streamId }
					});
					break;
				}
				case eParticaAction.CONTENT_STREAM_DELETE_STREAM: {
					this.ShowSnackbar("delete the stream here.");
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(e, `Unable to process event ${event.action}`);
		}
	}

	private async init() {
		try {
			this.LoadingStart();
			this.streams = await this.svc.getContentStreams(this.id);
			await this.getAccountNav(this.id);
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}

	private async mounted() {
		try {
			this.svc = this.particaServices.getContentStreamService();
			this.metadata.name = "Content Streams";
			await this.init();

		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading your content streams (${this.id})`
			);
		}
	}



}
